import { Button, BodyText, Title } from 'src/viewLayer/components/DesignSystem';

import { t } from 'src/viewLayer/helpers/translations';
import { FallbackActionType } from './types';
import { CenteredLayout } from './ErrorScreen.styled';

export const ErrorScreen = ({ fallbackAction }: FallbackActionType): JSX.Element => (
  <CenteredLayout gap="2rem" direction="stack" align="center" alignItems="center" data-testid="error-screen">
    <Title size={{ xxxsmall: 'small', medium: 'default' }} textAlign="center">{t('error.head')}</Title>
    <BodyText size="large">{t('error.body')}</BodyText>
    <Button onClick={fallbackAction}>
      {t('error.cta')}
    </Button>
  </CenteredLayout>
);
